module.exports = __webpack_public_path__ + "img/squishie-blue.8488f51f.png";